import { Button } from '@/components/ui/button';
import { Calendar } from '@/components/ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { cn } from '@/lib/utils';
import { CalendarIcon } from '@radix-ui/react-icons';
import { format } from 'date-fns';
import { ComponentType, PropsWithChildren, Fragment, useState } from 'react';
import { SelectSingleEventHandler } from 'react-day-picker';

type Props = {
	TriggerWrapper?: ComponentType<PropsWithChildren>;
	value: Date | null;
	onChange: SelectSingleEventHandler;
	isFullWidth?: boolean;
	placeholder?: string;
	isDisabledFn?: (date: Date) => boolean;
};

export default function DatePicker({
	TriggerWrapper = Fragment,
	value,
	onChange,
	isFullWidth,
	placeholder = 'Select a date',
	isDisabledFn = () => false
}: Props) {
	const [open, setOpen] = useState(false);

	return (
		<Popover open={open} onOpenChange={setOpen}>
			<TriggerWrapper>
				<PopoverTrigger asChild>
					<Button
						variant={'outline'}
						className={cn(
							'w-[240px] pl-3 text-left font-normal',
							!value && 'text-muted-foreground',
							isFullWidth && 'w-full'
						)}
					>
						{value ? format(value, 'PPP') : <span>{placeholder}</span>}
						<CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
					</Button>
				</PopoverTrigger>
			</TriggerWrapper>
			<PopoverContent className="w-auto p-0" align="start">
				<Calendar
					mode="single"
					selected={value ? new Date(value) : undefined}
					onSelect={(...args) => {
						onChange(...args);
						setOpen(false);
					}}
					disabled={date => isDisabledFn(date) ?? false}
				/>
			</PopoverContent>
		</Popover>
	);
}
